import { render, staticRenderFns } from "./ComfirmSendForm.vue?vue&type=template&id=d1eea5fa&"
import script from "./ComfirmSendForm.vue?vue&type=script&lang=js&"
export * from "./ComfirmSendForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports